<template>
  <div id="homePage-2">
    <div class="part-title">
      <h3>智能触手可及,智能改变生活</h3>
      <p>深圳市青橙无线科技有限公司</p>
    </div>
    <div class="part-content">
      <div class="part-swiper">
        <div class="swiper-left">
          <h3>青橙计划</h3>
          <span class="Grader"></span>
          <p>青橙无线科技始终秉承服务客户需求，追求客户体验的发展宗旨，围绕智能硬件，融合最先进的人工智能技术应用于生活的方方面面，从体征感知到环境感知，从无线传感到万物互联，始终将人工智能等新一代信息技术贯穿于感知、认知、互联、计算的全过程。追求极致体验，护航更加健康、更加智能的新生活。
          </p>
        </div>
        <div class="swiper-right">
          <img width="870" height="500" src="~assets/img/banner/watch_8.jpg" alt="sashereman">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTwo',
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
#homePage-2 {
  width: 100%;
  height: 100%;
  padding-top: 120px;
  background: url("~assets/img/banner/bg_diandian.png") center no-repeat,
              linear-gradient(to right,#fff 0,#f1f2f6 100%);
  background-size: cover;
}
.part-title {
  position: relative;
  width: 100%;
  margin-bottom: 65px;
  -webkit-transition: all 1s;
  transition: all 1s;
  text-align: center;
  h3 {
    margin-bottom: 10px;
    font-size: 30px;
    font-weight: 700;
    color: #ff6a00;
  }
  p {
    font-size: 16px;
    color: #acadb3;
  }
}
.part-content {
  position: relative;
  .part-swiper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 35px
  }
  .swiper-left {
    margin: auto;
    text-align: left;
    h3 {
      font-size: 20px;
      font-weight: 700;
      color: #ff6a00;
    }
    .Grader {
      display: inline-block;
      min-width: 83px;
      height: 2px;
      margin: 10px 0;
      margin-top: 15px;
      margin-bottom: 30px;
      background: linear-gradient(to right,#ff6a00 0,#ff6a00 100%);
      background-size: cover;
    }
    p {
      font-size: 14px;
      line-height: 25px;
      max-width: 410px;
      text-align: left;
      color: #95969d;
    }
  }
  .swiper-right {
    margin: auto;
    box-shadow: -20px 20px 40px #ccc;
  }
}
</style>
